// src/redux/reducers/learnerReducer.js

// Action Types
export const SET_LEARNER_DATA = "SET_LEARNER_DATA";
export const PATCH_LEARNER_DATA = "PATCH_LEARNER_DATA";
export const SET_LEARNER_LOADING = "SET_LEARNER_LOADING";
export const SET_LEARNER_ERROR = "SET_LEARNER_ERROR";
export const CLEAR_LEARNER_DATA = "CLEAR_LEARNER_DATA";

// Initial State
const initialState = {
  learnerData: null,
  loading: false,
  error: null,
};

// Reducer
const learnerReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_LEARNER_DATA:
      return {
        ...state,
        learnerData: action.payload,
        loading: false,
        error: null,
      };

    case PATCH_LEARNER_DATA: {
      const partial = action.payload || {};
      if (!Object.keys(partial).length) return state;
      return {
        ...state,
        learnerData: state.learnerData
          ? { ...state.learnerData, ...partial }
          : { ...partial },
        loading: false,
        error: null,
      };
    }

    case SET_LEARNER_LOADING:
      return {
        ...state,
        loading: action.payload,
        error: null,
      };

    case SET_LEARNER_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };

    case CLEAR_LEARNER_DATA:
      return {
        ...state,
        learnerData: null,
        loading: false,
        error: null,
      };

    default:
      return state;
  }
};

export default learnerReducer;
